<template>
  <div class="level">
    <div class="jiangli_top">
      <icon name="arrow-left" @click="$router.go(-1)" />
      <p>{{$t('m.hz_span28')}}</p>
    </div>
    <div class="level_con">
      <list
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="getData"
      >
        <div
          v-for="(item, index) in list"
          :key="index"
          style="background-color: #ffffff; padding:10px 15px; border-bottom: 1px solid #ebedf0;"
        >
        
        <div style="margin-bottom: 5px;display:flex;justify-content: space-between;align-items:center;font-size:14px;border-bottom:1px solid #eee;padding-bottom:10px;">
            <img src="../../assets/images/new/xinzhuan.png" style="width: 20px;height: 20px;" alt="">
         <div style="flex:1;">{{item.type==1?$t('m.hz_span9'):$t('m.hz_span8')}} </div>
            <div style="color:red;font-size:13px;">
              <span v-if="item.status === 0">{{$t('m.jl_span4')}}</span>
              <span v-if="item.status === 1">{{$t('m.jl_span5')}}</span>
              <span v-if="item.status === 2">{{$t('m.jl_span6')}}</span>
              <span v-if="item.status === 3">{{$t('m.jl_span7')}}</span>
            </div>
        </div>
          <!-- <div style="display: flex; align-items: center; width: 60%;"> -->
            <!-- <icon
              name="gold-coin"
              style="margin-right: 10px"
              size="36"
              color="#FF1C40"
            /> -->
            <div style="margin-bottom: 5px;font-size:12px;color:#666;margin-top:5px;">{{$t('m.tz_span4')}}：{{ item.amount }}</div>
              <div style="margin-bottom: 5px;font-size:12px;color:#666;">{{$t('m.jf_span7')}}：{{ item.remark }}</div>
              <div style="margin-bottom: 5px;font-size:12px;color:#666;">{{$t('m.jl_span3')}}：{{ item.reply }}</div>
              <div style="color: #666; font-size: 12px;">
{{$t('m.tz_span5')}}：{{ createDate(item.created_at) }}
              </div>
              
            <!-- </div> -->
        
        </div>
      </list>
    </div>
  </div>
</template>

<script>
import { getWithdraw1 } from "../../api/user";
import Icon from "vant/lib/icon";
import List from "vant/lib/list";
import "vant/lib/list/style";
export default {
  name: "index",
  components: {
    Icon,
    List
  },
  data() {
    return {
      currentDate: new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      show: false,
      list: [],
      loading: false,
      finished: false,
      page: 1
    };
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      };
    }
  },
  methods: {
    getData() {
      getWithdraw1({ page: this.page }).then(res => {
        console.log(res.data.data);
        if (res.data.data.length > 0) {
          this.list = this.list.concat(res.data.data);
          this.page++;
        } else {
          this.finished = true;
        }
        this.loading = false;
      });
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    }
  }
};
</script>

<style scoped>
.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  position: relative;
}
.jiangli_top i {
  position: absolute;
  top: 13px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 24px;
}
.level_con {
  padding: 20px 15px;
}
</style>
